export function ProfilePage() {
  return (
    <div className="p-6">
      <p className="text-muted-foreground">
        User profile will go here. This is a placeholder page.
      </p>
    </div>
  );
}
